<template>
    <q-page class=" q-pa-lg ">
        <!-- DIALOG PARA VER LOS PDF -->
        <q-dialog v-model="dialogPDF" transition-show="scale" transition-hide="scale" maximized>
            <visor-pdf ref="miComponenteHijo" @CloseDialogPdf="dialogPDF = false"></visor-pdf>
        </q-dialog>

        <q-dialog v-model="dialogAplicarCC" transition-show="scale" transition-hide="scale" persistent> 
            <q-card>
                <q-card-section>
                    <q-toolbar>
                        <q-toolbar-title>
                            {{ $t('centroCostos.reconcile.assignCc') }}
                        </q-toolbar-title>

                        <q-btn round color="red" icon="mdi-close" dense v-close-popup>
                            <q-tooltip>
                                {{ $t('buttons.close') }}
                            </q-tooltip>
                        </q-btn>
                    </q-toolbar>
                    <q-separator class="full-width" color="primary" inset size="4px" />
                </q-card-section>
                <q-card-section>
                    <div class="row q-my-mb">
                        <div class="col-12">
                            <q-input type="file" accept=".xlsx,.xls" @change="onFileChange" outlined />
                        </div>
                        <div class="col-12 q-mt-md">
                            <q-btn color="primary" class="full-width" icon="mdi-import" label="Aplicar Centros"
                                @click="asignaCentrosExcel()" />
                            <!-- <q-btn size="md" color="blue-10" round icon="mdi-export" >
                                <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                    content-style="font-size: 14px">Aplicar centros</q-tooltip>
                            </q-btn> -->
                        </div>
                    </div>
                </q-card-section>

            </q-card>
        </q-dialog>



        <q-dialog v-model="dialogAsignaCc" persistent transition-show="scale" transition-hide="scale">
            <q-card style="max-width: 800px;">
                <q-card-section>
                    <q-toolbar>
                        <q-toolbar-title>
                            {{ $t('centroCostos.reconcile.assignCc') }}
                        </q-toolbar-title>
                        <q-btn dense round color="green" icon="mdi-content-save" class="q-mr-sm"
                            @click="postPolizaCC()">
                            <q-tooltip>
                                {{ $t('buttons.save') }}
                            </q-tooltip>
                        </q-btn>
                        <q-btn round color="red" icon="mdi-close" dense v-close-popup>
                            <q-tooltip>
                                {{ $t('buttons.close') }}
                            </q-tooltip>
                        </q-btn>
                    </q-toolbar>
                    <q-separator class="full-width" color="primary" inset size="4px" />
                </q-card-section>
                <q-card-section>
                    <div class="col">
                        <q-select v-model="selectCc" class="q-mb-md" :options="itemsCc" dense filled
                            :label="$t('centroCostos.reconcile.accountCenter')" option-label="descripcion" />
                    </div>
                </q-card-section>
            </q-card>
        </q-dialog>

        <!-- <q-table class="shadow-0 header-tabla" :data="itemsPolizas" :pagination="initialPagination" :columns="columns" row-key="_id" :filter="filter" selection="multiple" :selected.sync="selectedPolizas">
            <template v-slot:body-selection="scope">
                <q-checkbox :value="scope.selectedPolizas" />
            </template> -->
        <q-table :filter="filter" selection="multiple" :selected.sync="selectedPolizas"
            class="my-sticky-column-table my-sticky-column-table-sec shadow-0 header-tabla" :data="itemsPolizas"
            :columns="columns" row-key="_id" :pagination="initialPagination">
            <template v-slot:body-selection="scope">
                <q-checkbox :value="scope.selectedPolizas" />
            </template>
            <template v-slot:top>
                <div class="row q-col-gutter-sm q-mb-lg full-width ">
                    <div class="col-12 col-md-12">
                        <div class=" text-h5">{{ $t('centroCostos.reconcile.title') }}</div>
                    </div>
                    <div class="col-12 col-md-3">
                    </div>
                </div>

                <div class="row full-width no-grap justify-end">
                    <q-input v-model="fehaIMasked" style="width:250px" filled :label="$t('centroCostos.reconcile.initialDate')" class="q-mr-sm"
                        name="event" outlined dense>
                        <template v-slot:before>
                            <q-icon name="event" color="primary" />
                        </template>
                        <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                            <q-date v-model="fechaI" @input="UltimoDiaMes">
                                <div class="row items-center justify-end">
                                    <q-btn v-close-popup label="Ok" color="primary" flat />
                                </div>
                            </q-date>
                        </q-popup-proxy>
                    </q-input>

                    <!-- FECHA FINAL -->
                    <q-input v-model="fechaFMasked" style="width:250px" filled :label="$t('centroCostos.reconcile.finalDate')" class="q-mr-sm"
                        name="event" outlined dense>
                        <template v-slot:before>
                            <q-icon name="event" color="primary" />
                        </template>
                        <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                            <q-date v-model="fechaF">
                                <div class="row items-center justify-end">
                                    <q-btn v-close-popup label="Ok" color="primary" flat />
                                </div>
                            </q-date>
                        </q-popup-proxy>
                    </q-input>
                    <q-select v-model="tipoSelected" style="width:250px" class="q-mr-md" :options="itemsTipo" dense
                        filled :label="$t('centroCostos.reconcile.type')" />
                    <!-- <div class="col-12 col-md-2">
                        <q-select v-model="estatusSelected" style="width:80%"   class="q-mr-md" :options="itemsSelected"
                        dense filled label="Estatus" />
                    </div> -->

                    <!-- <div class="col-12 "> -->
                    <q-btn size="md" class="q-mr-sm" color="blue-10" round icon="mdi-magnify" @click="getPolizas()">
                        <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                            content-style="font-size: 14px">{{ $t('centroCostos.reconcile.search') }}</q-tooltip>
                    </q-btn>
                    <q-btn size="md" class="q-mr-sm" color="blue-10" round icon="mdi-checkbox-multiple-marked" @click="getCc()">
                        <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                            content-style="font-size: 14px">{{ $t('centroCostos.reconcile.assignCc') }}</q-tooltip>
                    </q-btn>
                    <q-btn size="md" class="q-mr-sm" color="blue-10" round icon="mdi-export" @click="exportExcel()">
                        <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                            content-style="font-size: 14px">{{ $t('centroCostos.reconcile.exportExcel') }}</q-tooltip>
                    </q-btn>
                    <q-btn size="md" color="blue-10" round icon="mdi-import" @click="dialogAplicarCC = true">
                        <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                            content-style="font-size: 14px">{{ $t('centroCostos.reconcile.importExcel') }}</q-tooltip>
                    </q-btn>

                    <!-- </div> -->
                </div>
            </template>
            <template v-slot:body="props">
                <q-tr :props="props">
                    <q-td auto-width key="acciones">
                        <q-checkbox v-model="props.selected"></q-checkbox>
                    </q-td>
                    <q-btn size="md" color="red-10" rounded flat dense icon="mdi-file-pdf-box"
                        @click="openPdf(props.row)">
                        <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                            content-style="font-size: 14px">{{ $t('centroCostos.reconcile.viewPdf') }}</q-tooltip>
                    </q-btn>
                    <q-td key="centroCostos" :props="props">{{ props.row.centroCostos }}</q-td>
                    <q-td key="fecha" :props="props">{{ formatDate(props.row.fecha) }}</q-td>
                    <q-td key="rfc" :props="props">{{ props.row.rfc }}</q-td>
                    <q-td key="nombre" :props="props">{{ props.row.nombre }}</q-td>
                    <q-td key="total" :props="props">{{ formatCurrency(props.row.total) }}</q-td>
                    <q-td key="usoCfdi" :props="props">{{ props.row.usoCfdi }}</q-td>
                    <q-td key="tipo" :props="props">{{ props.row.tipo }}</q-td>
                    <q-td key="tipoComprobante" :props="props">{{ props.row.tipoComprobante }}</q-td>
                    <q-td key="folioFiscal" :props="props">{{ props.row.folioFiscal }}</q-td>
                    <q-td key="descripcion" :props="props">{{ props.row.descripcion }}</q-td>
                </q-tr>
            </template>
        </q-table>
    </q-page>
</template>
<script>
import { format } from 'date-fns';
import { parse } from 'date-fns';
import { endOfMonth } from 'date-fns';
import { es } from 'date-fns/locale';
import axios from 'axios'
import * as XLSX from 'xlsx';
import { QSpinnerCube } from 'quasar'
import moment from 'moment';
import visorPdf from '../PDF/VisorPDF.vue';

export default {
    components: {
        visorPdf
    },
    data() {
        return {
            fechaI: new Date(),
            fechaF: new Date(),

            dialogNuevo: false,
            dialogAsignaCc: false,
            itemsPolizas: [],
            selectedPolizas: [],
            itemsCc: [],
            columns: [
                { name: 'acciones', align: 'center', label: this.$t('centroCostos.reconcile.actions'), field: 'acciones', sortable: true },
                { name: 'centroCostos', align: 'left', label: this.$t('centroCostos.reconcile.accountCenter'), field: 'centroCostos', sortable: true },
                { name: 'fecha', align: 'left', label: this.$t('centroCostos.reconcile.initialDate'), field: 'fecha', sortable: true },
                { name: 'rfc', align: 'left', label: 'RFC', field: 'rfc', sortable: true },
                { name: 'nombre', align: 'left', label: this.$t('centroCostos.list.description'), field: 'nombre', sortable: true },
                { name: 'total', align: 'right', label: this.$t('reportes.common.amount'), field: 'total', sortable: true },
                { name: 'usoCfdi', align: 'left', label: this.$t('centroCostos.reconcile.useCfdi'), field: 'usoCfdi', sortable: true },
                { name: 'tipo', align: 'left', label: this.$t('actions.type'), field: 'tipo', sortable: true },
                { name: 'tipoComprobante', align: 'left', label: this.$t('centroCostos.reconcile.comprobanteType'), field: 'tipoComprobante', sortable: true },
                { name: 'folioFiscal', align: 'left', label: this.$t('centroCostos.reconcile.fiscalFolio'), field: 'folioFiscal', sortable: true },
                { name: 'descripcion', align: 'left', label: this.$t('centroCostos.reconcile.description'), field: 'descripcion', sortable: true, },
            ],
            filter: '',
            initialPagination: {
                descending: false,
                page: 1,
                rowsPerPage: 10
            },
            itemsTipo: [
                { label: "Todos", value: "Todos" },
                { label: "Ingresos", value: "Ingreso" },
                { label: "Compras/Gastos", value: "Egreso" },
                { label: "Nómina", value: "Nomina" },
            ],
            tipoSelected: { label: "Todos", value: "Todos" },
            itemsSelected: ["Todos", "Conciliados", "No Conciliados"],
            estatusSelected: null,
            selectCc: null,

            dialogPDF: false,

            itemsCCM: [],
            dialogAplicarCC: false
        }
    },
    computed: {
        token() {
            return this.$store.state.usuario;
        },
        fehaIMasked() {
            moment.locale('es-mx');
            return this.fechaI ? moment(this.fechaI).format('DD/MMMM/yyyy') : ''
        },
        fechaFMasked() {
            moment.locale('es-mx');
            return this.fechaF ? moment(this.fechaF).format('DD/MMMM/yyyy') : ''
        },
    },

    created() {
        this.getCc();
    },

    methods: {
        nueCc() {
            this.dialogNuevo = true;
        },

        async postCc() {
            const centroCostos = this.centro;
            if (!centroCostos.descripcion) {
                this.$q.notify({ type: 'negative', message: this.$t('centroCostos.list.enterDescription'), color: 'red' })
                return;
            }
            this.$q.loading.show({ spinner: QSpinnerCube, spinnerColor: 'purple', spinnerSize: 140, message: this.$t('centroCostos.list.wait'), messageColor: 'white' })
            try {
                let response = await axios.post('CentrosCostos/PostCentroCostosAsync/erp_' + this.token.rfc, centroCostos)

                this.$q.loading.hide()
                this.$q.notify({ type: 'positive', message: this.$t('centroCostos.list.savedSuccess') })
                this.dialogNuevo = false
                await this.getPolizas();
            } catch (error) {
                console.log(error)
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', message: this.$t('centroCostos.list.errorSave'), color: 'red' })
            }
        },

        async getPolizas() {
            this.$q.loading.show({ spinner: QSpinnerCube, spinnerColor: 'purple', spinnerSize: 140, message: 'Espere...', messageColor: 'white' })
            try {
                let fechaI = new Date(this.fechaI);
                let fechaF = new Date(this.fechaF);

                fechaI = format(fechaI, 'yyyy-MM-dd');
                fechaF = format(fechaF, 'yyyy-MM-dd');

                const response = await axios.get(`CentrosCostos/GetPolizaCentroCostosAsync/erp_${this.token.rfc}/${fechaI}/${fechaF}`)

                if (this.tipoSelected.value === "Todos") {
                    const listaFinal = response.data;
                    this.itemsPolizas = listaFinal;
                }
                if (this.tipoSelected.value === "Ingreso") {
                    const listaFinal = response.data.filter(f => f.tipo === this.tipoSelected.value);
                    this.itemsPolizas = listaFinal;
                }
                if (this.tipoSelected.value === "Egreso") {
                    const listaFinal = response.data.filter(f => f.tipo === this.tipoSelected.value && f.tipoComprobante != "N");
                    this.itemsPolizas = listaFinal;
                }
                if (this.tipoSelected.value === "Nomina") {
                    const listaFinal = response.data.filter(f => f.tipoComprobante === "N");
                    this.itemsPolizas = listaFinal;
                }
                this.$q.loading.hide();
            } catch (error) {
                console.log(error)
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', message: this.$t('centroCostos.list.errorFetch'), color: 'red' })
            }
        },

        async getCc() {
            this.$q.loading.show({ spinner: QSpinnerCube, spinnerColor: 'purple', spinnerSize: 140, message: this.$t('centroCostos.list.wait'), messageColor: 'white' })
            try {
                const response = await axios.get('CentrosCostos/GetCentroCostosAsync/erp_' + this.token.rfc)
                this.itemsCc = response.data;
                this.$q.loading.hide();
                if (this.selectedPolizas.length != 0) {
                    this.dialogAsignaCc = true
                }
            } catch (error) {
                console.log(error)
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', message: this.$t('centroCostos.list.errorFetch'), color: 'red' })
            }
        },

        formatCurrency(value) {
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },

        formatDate(value) {
            const fecha_ = value.replace("Z", "");
            const fecha = new Date(fecha_)
            return new Intl.DateTimeFormat('es-MX', {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            }).format(fecha);
        },

        OpenDialogConfirm() {

        },

        async postPolizaCC() {
            for (let i of this.selectedPolizas) {
                await this.PostIdPolizaCC(this.selectCc._id, i._id);
            }
        },

        async PostIdPolizaCC(idCC, idPoliza) {
            try {
                const obj = {
                    idCentroCostos: idCC,
                    idPoliza: idPoliza
                }
                const response = await axios.put(`CentrosCostos/PutCentroCostosPolizaAsync/erp_${this.token.rfc}`, obj)
                this.itemsCc = response.data;
            } catch (error) {
                console.log(error)
            }
        },

        UltimoDiaMes() {
            let fechaI = this.fechaI;
            fechaI = fechaI.replaceAll('/', '-');
            const fecha = parse(fechaI, 'yyyy-MM-dd', new Date());
            const ultimoDiaDelMes = endOfMonth(fecha);
            this.fechaF = ultimoDiaDelMes;
        },

        exportExcel() {
            try {
                const datos = this.itemsPolizas;
                const cabecera = datos.map(item => ({
                    "ID": item._id,
                    "CENTRO DE COSTOS": item.centroCostos,
                    "FECHA": item.fecha,
                    "RFC": item.rfc,
                    "NOMBRE": item.nombre,
                    "TOTAL": item.total,
                    "USO DE CFDI": item.usoCfdi,
                    "TIPO DE COMPROBANTE": item.tipoComprobante,
                    "FOLIO FISCAL": item.folioFiscal,
                }))

                const hoja = XLSX.utils.json_to_sheet(cabecera);
                const libro = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(libro, hoja, "Hoja 1");

                // 4. Generar el archivo y disparar la descarga
                XLSX.writeFile(libro, "Centro de costos.xlsx");
            }
            catch (error) {
                console.log(error)
            }
        },

        onFileChange(e) {
            this.itemsCCM = [];
            const file = e.target.files[0]
            if (!file) return

            const reader = new FileReader()
            reader.onload = (evt) => {
                const data = new Uint8Array(evt.target.result)
                const workbook = XLSX.read(data, { type: 'array' })

                const sheetName = workbook.SheetNames[0]
                const worksheet = workbook.Sheets[sheetName]

                const rows = XLSX.utils.sheet_to_json(worksheet, {
                    header: 1,
                    defval: null
                })

                this.itemsCCM = rows
                    .slice(1)
                    .filter(r => r[0] !== null || r[1] !== null)
                    .map(r => ({
                        col0: r[0],
                        col1: r[1]
                    }))
            }
            reader.readAsArrayBuffer(file)
        },

        asignaCentrosExcel() {
            this.$q.loading.show({ spinner: QSpinnerCube, spinnerColor: 'purple', spinnerSize: 140, message: 'Asignando centro de costos...', messageColor: 'white' })
            const datosE = this.itemsCCM
            console.log(datosE);
            let cuenta = 0;
            try {
                for (let i of datosE) {
                    let x = this.buscaCC(i.col1)
                    if (x) {
                        this.PostIdPolizaCC(x, i.col0);
                        cuenta++;
                    }
                }
            } catch (error) {
                // this.$q.loading.hide();
            }
            console.log(cuenta);
            this.dialogAplicarCC = false
            this.itemsCCM = []
            this.$q.notify({ type: 'positive', message: `Listo, se asigaron ${cuenta} centro de costos` })
            this.$q.loading.hide();
        },

        buscaCC(item) {
            const clave = item.toString();
            let objCC = this.itemsCc.find(c => c.clave === clave);
            return objCC?._id || null
        },

        openPdf(item) {
            console.log(item)
            try {
                this.dialogPDF = true;
                const tipo = item.tipo;
                if (tipo === 'Egreso') {
                    this.$store.state.vistaPreviaStore.tipo = "R"
                    this.$store.state.vistaPreviaStore.tipoComprobanteInterno = "FACTURA"
                    if (item.tipoComprobante === "N") {
                        this.$store.state.vistaPreviaStore.tipoComprobanteInterno = "NOMINA"
                        this.$store.state.vistaPreviaStore.tipo = "E"
                    } else if (item.tipoComprobante === "P") {
                        this.$store.state.vistaPreviaStore.tipoComprobanteInterno = "PAGO"
                    } else if (item.tipoComprobante === "E") {
                        this.$store.state.vistaPreviaStore.tipo = "E"
                    }
                    // if (this.poliza.listaXml[0].tipoComprobante === "E") {
                    //     this.$store.state.vistaPreviaStore.tipo = "E"
                    // }

                } else if (tipo === 'Ingreso') {
                    this.$store.state.vistaPreviaStore.tipo = "E"
                    this.$store.state.vistaPreviaStore.tipoComprobanteInterno = "FACTURA"
                    if (item.tipoComprobante === "N") {
                        this.$store.state.vistaPreviaStore.tipoComprobanteInterno = "NOMINA"
                        this.$store.state.vistaPreviaStore.tipo = "R"
                    } else if (item.tipoComprobante === "P") {
                        this.$store.state.vistaPreviaStore.tipoComprobanteInterno = "PAGO"
                    } else if (item.tipoComprobante === "E") {
                        this.$store.state.vistaPreviaStore.tipo = "R"
                    }
                    // if (this.poliza.listaXml[0].tipoComprobante === "E") {
                    //     this.$store.state.vistaPreviaStore.tipo = "R"
                    // }
                }

                this.$nextTick(() => {
                    this.$store.state.vistaPreviaStore.folioFiscal = item.folioFiscal.toUpperCase();
                    this.$store.state.vistaPreviaStore.color = "19775C"
                    this.$store.state.vistaPreviaStore.rfc = this.token.rfc
                    this.$refs.miComponenteHijo.VerComprobante();
                }
                );
                // this.$refs.miComponenteHijo.VerPolizaPdf();

            } catch (error) {
                console.log(error)
            }
        },
    }
}
</script>

<style></style>